import { render, staticRenderFns } from "./tab_view.vue.js?vue&type=template&id=5b09b780!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tab_view.vue?vue&type=template&id=5b09b780"
import script from "./tab_view.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tab_view.vue?vue&type=script&lang=js"
export * from "./tab_view.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tab_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b09b780')) {
      api.createRecord('5b09b780', component.options)
    } else {
      api.reload('5b09b780', component.options)
    }
    module.hot.accept("./tab_view.vue.js?vue&type=template&id=5b09b780!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tab_view.vue?vue&type=template&id=5b09b780", function () {
      api.rerender('5b09b780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "groups_projects/components/tab_view.vue"
export default component.exports